import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  createTheme,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteCountry,
  getCountryById,
  postCountry,
  updateCountry,
} from "../../../../api/country";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyCountry() {
  return {
    name: "",
    localName: "",
    active: true,
    prefix: "",
    code: "",
  };
}

export default function EditCountryPage() {
  const countryId = useParams().id;
  const history = useHistory();
  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  const [country, setCountry] = useState(getEmptyCountry());
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  useEffect(() => {
    if (!countryId) {
      disableLoadingData();
      return;
    }

    getCountryById(countryId)
      .then((res) => {
        setCountry(res.data);
        disableLoadingData();
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get the country.",
        });
        history.push("/countries");
      });
  }, [countryId, disableLoadingData, history]);

  function saveCountry() {
    if (!countryId) {
      postCountry(country)
        .then((res) => {
          alertSuccess({
            title: "Guardado!",
            customMessage: "Country created correctamente.",
          });
          history.push("/countries");
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save the country.",
          });
        });
    } else {
      updateCountry(countryId, country)
        .then((res) => {
          alertSuccess({
            title: "Guardado!",
            customMessage: "Changes saved correctamente.",
          });
          history.push("/countries");
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save the country.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setCountry({ ...country, [element]: event.target.value });
  };

  if (isLoadingData)
    return <ContentSkeleton />;

  return (
    <>
      <Card>
        <CardHeader title="Editar país"></CardHeader>
        <CardBody>
          <div className="d-flex align-item-center">
            <div className="col-5">
              <TextField
                label="Nombre internacional"
                value={country.name}
                onChange={handleChange("name")}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-5">
              <TextField
                label="Nombre local"
                value={country.localName}
                onChange={handleChange("localName")}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
          </div>

          <div className="d-flex align-item-center">
            <div className="col-2">
              <TextField
                label="Código ISO"
                value={country.code}
                onChange={handleChange("code")}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-2">
              <TextField
                label="Prefijo"
                value={country.prefix}
                onChange={handleChange("prefix")}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
          </div>

          <br />

          <FormControlLabel
            control={
              <Checkbox
                checked={country.active}
                onChange={() => setCountry({ ...country, active: !country.active })}
                name="checkActive"
              />
            }
            label="Active"
          />
        </CardBody>
      </Card>


      <div style={{ display: "flex", flexDirection: "row" }}>
        <Button
          onClick={() => history.push("/countries")}
          variant="outlined"
          style={{ marginRight: "20px" }}
        >
          Atrás
        </Button>

        <Button
          onClick={() => saveCountry()}
          variant="outlined"
          color="primary"
          style={{ marginRight: "20px" }}
        >
          Guardar país
        </Button>

        {countryId && (
          <>
            <MuiThemeProvider theme={theme}>
              <Button
                onClick={() => setOpenConfirmDialog(true)}
                variant="outlined"
                color="secondary"
                style={{ marginRight: "20px" }}
              >
                Eliminar país
              </Button>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: "auto",
                }}
              ></div>
            </MuiThemeProvider>

            <ConfirmDialog
              title={"Seguro que quieres delete this country?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteCountry(countryId)
                  .then((res) => {
                    alertSuccess({
                      title: "Eliminado!",
                      customMessage: "Country deleted correctamente.",
                    });
                    history.push("/countries");
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "No se ha podido eliminar el the country.",
                    });
                  });
              }}
            />
          </>
        )}
      </div>
    </>
  );
}
